import {arraysEqual, createArray, greaterThan} from "./array-utils.js";
import {diffToHuman, formatTime, parseDatetimeTimezone, safeParseDate, translateMonth, translateWeekDay} from "./date-utils.js";
import {clearServiceWorker, getSearchParamId, isSameDomain, updateActiveLink} from "./dom-utils.js";
import {getCurrentDayGroupName, getTodayHolidayData, getTodayVacationData} from "./holiday-utils.js";
import {convertNumberToDay, getBestMatchDayIndex} from "./day-utils.js";
import {processContents, renderText, wrapTextInArialIfNeeded} from "./react-utils.jsx";
import {checkIsValid, convertToSafeText, directionToText, formatMoney, getDirectionTitle, includeDotIfNotExists, normalize, resumeInfoLine, getContrastColor} from "./string-utils.js";
import {compareIntervals, formatFriendlyDuration} from "@/lib/interval-utils.js";
import generateVehicleDescription from "@/lib/bus-repo-utils.js";

export default class Util {
  static updateActiveLink = updateActiveLink;
  static arraysEqual = arraysEqual;
  static createArray = createArray;
  static formatTime = formatTime;
  static resumeInfoLine = resumeInfoLine;
  static isSameDomain = isSameDomain;
  static convertToSafeText = convertToSafeText;
  static normalize = normalize;
  static convertNumberToDay = convertNumberToDay;
  static directionToText = directionToText;
  static getDirectionTitle = getDirectionTitle;
  static formatMoney = formatMoney;
  static renderText = renderText;
  static processContents = processContents;
  static wrapTextInArialIfNeeded = wrapTextInArialIfNeeded;
  static translateMonth = translateMonth;
  static clearServiceWorker = clearServiceWorker;
  static diffToHuman = diffToHuman;
  static getTodayHolidayData = getTodayHolidayData;
  static getTodayVacationData = getTodayVacationData;
  static getCurrentDayGroupName = getCurrentDayGroupName;
  static greaterThan = greaterThan;
  static translateWeekDay = translateWeekDay;
  static parseDatetimeTimezone = parseDatetimeTimezone;
  static safeParseDate = safeParseDate;
  static getSearchParamId = getSearchParamId;
  static getBestMatchDayIndex = getBestMatchDayIndex;
  static checkIsValid = checkIsValid;
  static compareIntervals = compareIntervals;
  static formatFriendlyDuration = formatFriendlyDuration;
  static includeDotIfNotExists = includeDotIfNotExists;
  static generateVehicleDescription = generateVehicleDescription;
  static getContrastColor = getContrastColor;
}
